import React, { FC, useCallback, ChangeEvent, useMemo } from 'react';
import dropDownOverlayStyles from 'src/shared/DropDownWithSearch/index.module.scss';
import { Input, Form } from 'src/common';
import { useTranslation } from 'react-i18next';
import { faSearch, faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import debounce from 'lodash/debounce';
import { useLinkedBidsSearchArgs } from 'src/reactiveVars/SelectedBidsSearchArgsVar';

const BidPickerSearch: FC = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [searchVar, updateSearch] = useLinkedBidsSearchArgs();

  const onSearch = useMemo(
    () =>
      debounce((e: ChangeEvent<HTMLInputElement>) => {
        updateSearch(e.target.value);
      }, 300),
    [updateSearch]
  );

  const onSearchClear = useCallback(() => {
    form.setFieldsValue({ search: '' });
    updateSearch(undefined);
  }, [form, updateSearch]);

  return (
    <div className={dropDownOverlayStyles.search}>
      <Input
        bordered={false}
        type="text"
        prefix={<FontAwesomeIcon icon={faSearch} />}
        placeholder={t('BidSpaces.searchBid')}
        onChange={onSearch}
        onKeyPress={e => e.stopPropagation()}
        suffix={
          !!searchVar && (
            <button onClick={onSearchClear} className={dropDownOverlayStyles.buttonClearSearch}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          )
        }
      />
    </div>
  );
};

export default BidPickerSearch;
